import { Box } from '@mui/material';

interface StatusIconCircleProps {
  icon: React.ReactNode;
  variant: 'accent' | 'destructive';
}

export default function StatusIconCircle({ icon, variant }: StatusIconCircleProps) {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 56,
        height: 56,
        borderRadius: '9999px',
        backgroundColor: variant === 'accent' ? theme.app.accentSurface : theme.app.secondary,
        color: variant === 'accent' ? theme.app.accent : theme.app.destructive,
      })}
    >
      {icon}
    </Box>
  );
}
